export default "__VITE_ASSET__CcRT0oRd__"